import React from 'react'

const referenceRoutes = [
    {
        path: '/reference/typePayments',
        component: React.lazy(() => import('./TypePayments/TypePayments')),
        accessPageName: 'TYPEPAYMENTS',
    },
    {
        path: '/reference/changeList',
        component: React.lazy(() => import('./ChangeList/ChangeList')),
        accessPageName: 'CHANGELIST',
    },
    {
        path: '/reference/employeesList',
        component: React.lazy(() => import('./Employees/EmployeesList')),
        accessPageName: 'EMPLOYEESLIST',
    },
    {
        path: '/reference/orderNotes',
        component: React.lazy(() => import('./Order/StatusOrder')),
        accessPageName: 'ORDERNOTES',
    },
    {
        path: '/reference/statusNotes',
        component: React.lazy(() => import('./Status/StatusNotes')),
        accessPageName: 'STATUSNOTES',
    },
    {
        path: '/reference/orderSource',
        component: React.lazy(() => import('./Order/OrderSource')),
        accessPageName: 'ORDERSOURCE',
    },
    {
        path: '/reference/Certificate',
        component: React.lazy(() => import('./Certificate/Certificate')),
        accessPageName: 'CERTIFICATE',
    },
    {
        path: '/reference/writeOff',
        component: React.lazy(() => import('./writeOff/writeOff')),
        accessPageName: 'WRITEOFF',
    },
    {
        path: '/reference/Marks',
        component: React.lazy(() => import('./Marks/Marks')),
        accessPageName: 'MARKS',
    },
    {
        path: '/reference/Suppliers',
        component: React.lazy(() => import('./Suppliers/Suppliers')),
        accessPageName: 'SUPPLIERS',
    },
    {
        path: '/reference/Units',
        component: React.lazy(() => import('./Units/Units')),
        accessPageName: 'UNITS',
    },
    {
        path: '/reference/Street',
        component: React.lazy(() => import('./Street/Street')),
        accessPageName: 'STREET',
    },
    {
        path: '/reference/Markup',
        component: React.lazy(() => import('./Markup/Markup')),
        accessPageName: 'MARKUP',
    },
    {
        path: '/reference/PositionWorker',
        component: React.lazy(() => import('./PositionWorker/PositionWorker')),
        accessPageName: 'POSITIONWORKER',
    },
    {
        path: '/reference/Discount',
        component: React.lazy(() => import('./Discount/Discount')),
        accessPageName: 'DISCOUNT',
    },
    {
        path: '/reference/KlientDirectory',
        component: React.lazy(() => import('./KlientDirectory/KlientDirectory')),
        accessPageName: 'KLIENTS',
    },
    {
        path: '/reference/Organization',
        component: React.lazy(() => import('./Organization/Organization')),
        accessPageName: 'ORGANIZATION',
    },
    {
        path: '/reference/Promocode',
        component: React.lazy(() => import('./Promocode/Promocode')),
        accessPageName: 'PROMOCODE',
    },
    {
        path: '/Settings/AffiliateList',
        component: React.lazy(() => import('../Settings/AffiliateList/AffiliateList')),
        accessPageName: 'AFFILIATELIST',
    },
    {
        path: '/Settings/Outlets',
        component: React.lazy(() => import('../Settings/Outlets/Outlets')),
        accessPageName: 'OUTLETS',
    },
    {
        path: '/Settings/UserList',
        component: React.lazy(() => import('../Settings/UserList/UserList')),
        accessPageName: 'USERLIST',
    },
    {
        path: '/NewProduct',
        component: React.lazy(() => import('../catalog/NewProduct')),
        accessPageName: 'NEWPRODUCT',
    },
    {
        path: '/NewProductCategory/([a-z0-9_]+)',
        component: React.lazy(() => import('../catalog/NewProduct')),
        accessPageName: 'NEWPRODUCT',
    },
    {
        path: '/NewProductArt/([a-z0-9_]+)',
        component: React.lazy(() => import('../catalog/NewProduct')),
        accessPageName: 'NEWPRODUCT',
    },
    {
        path: '/EditProduct/([0-9]+)',
        component: React.lazy(() => import('../catalog/NewProduct')),
        accessPageName: 'NEWPRODUCT',
    }

]

export default referenceRoutes
